import { render, staticRenderFns } from "./moblie-header.vue?vue&type=template&id=d4052cd4&scoped=true&"
import script from "./moblie-header.vue?vue&type=script&lang=js&"
export * from "./moblie-header.vue?vue&type=script&lang=js&"
import style0 from "./moblie-header.vue?vue&type=style&index=0&id=d4052cd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4052cd4",
  null
  
)

export default component.exports